import { render, staticRenderFns } from "./TabCustomerEmails.vue?vue&type=template&id=73e3009c&"
import script from "./TabCustomerEmails.vue?vue&type=script&lang=js&"
export * from "./TabCustomerEmails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports